const category = {
  displayField: 'title',
  name: 'Category',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'description',
      name: 'Description',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: { id: 'category', version: 8, updatedAt: '2023-02-10T22:51:54.625Z' }
};
export default category;